/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Heading = 'Website.Basket.Subscription.PriceInfo.Heading';
export const Description = 'Website.Basket.Subscription.PriceInfo.Description';
export const DescriptionIntroPrice = 'Website.Basket.Subscription.PriceInfo.DescriptionIntroPrice';
